import * as React from 'react';
import {
  Container, Divider, Card, Box, Typography, Link
} from '@mui/material'

import PageWrapper from 'components/PageWrapper';
import PageWrapperBox from 'components/PageWrapperBox';
import { useTranslation } from "react-i18next";

export default function ContactPage() {

    const { t } = useTranslation();

    return <PageWrapper>
            <PageWrapperBox>
            <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div">
                {t("contact.title")}
            </Typography>


                <Typography variant="body" color="text.primary_bold" component="div" >
                {t("contact.body")} <br/>
                <Link href={"mailto:" + t("common.email")} underline="none">
                {t("common.email")}
                </Link>
                </Typography>
            </PageWrapperBox>
    </PageWrapper>
}
